import {DomainObject, oneOf} from 'shared/store';
import {t} from 'shared/core';
import {observable, action, computed} from 'mobx';
import {Employee} from 'main/stores/employees';
import {User} from 'main/stores/users';
import TimeTrackingPaySchedule from './TimeTrackingPaySchedule';
import {TimeOffType} from 'main/stores/time_off';

class TimeTrackingPolicy extends DomainObject {
  @observable name;
  @observable state;

  @observable overtimePolicy;
  @observable weeklyOvertimeThreshold;
  @observable dailyOvertimeThreshold;
  @observable dailyDoubleOvertimeThreshold;
  @observable weekStartDay;
  @observable sendApprovedTimesheetEditedNotification;
  @observable sendPayPeriodEndedNotification;
  @observable sendEmployeeTimesheetReminder;

  @observable paySchedule;
  @observable employees;
  @observable assigneeType;
  @observable assigneeUser;

  @observable manuallyEnterHours;

  @observable lieuTimeEnabled;
  @observable lieuTimeMultiplier;
  @observable lieuTimeDoubleMultiplier;
  @observable lieuTimePTOType;

  @action merge(other) {
    super.merge(other, {
      paySchedule: TimeTrackingPaySchedule,
      employees: [Employee],
      assigneeUser: User,
      lieuTimePTOType: TimeOffType,
      overtimePolicy: oneOf(['standard', 'custom', 'exempt']),
      assigneeType: oneOf(['manager', 'specific_user'])
    });
  }

  @computed get hoursEnteredAsLabel() {
    return this.manuallyEnterHours ?
      t('time_tracking.manage.policies.edit.Total Hours'):
      t('time_tracking.manage.policies.edit.Start and End Time');
  }
}

export default TimeTrackingPolicy;
